module.exports = __webpack_public_path__ + "img/infoOur.a0bd7b10.png";